import { TrendUp, ChartBar } from '@phosphor-icons/react';

export default function SalesPerformanceSection({ performance, formatCurrency }) {
  if (!performance) return null;
  return (
    <div className="card-flat" data-testid="sales-performance-section">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold flex items-center gap-2">
          <TrendUp size={22} className="text-indigo-600" />
          Sales Performance
        </h2>
        <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
          {performance.sales_person_count} Sales Persons
        </span>
      </div>
      <div className="p-3 bg-indigo-50 border border-indigo-200 rounded-lg mb-4" data-testid="sp-total-commission">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-[10px] text-indigo-600 uppercase font-semibold">Total Commission Paid</p>
            <p className="text-xl font-bold text-indigo-700 font-mono">{formatCurrency(performance.total_commission)}</p>
          </div>
          <ChartBar size={32} className="text-indigo-300" />
        </div>
      </div>
      {performance.sales_persons.length > 0 ? (
        <div className="overflow-x-auto border border-gray-200 rounded-lg">
          <table className="w-full text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="text-left p-2.5 font-semibold text-gray-600">Sales Person</th>
                <th className="text-right p-2.5 font-semibold text-gray-600">Rate/Cyl</th>
                <th className="text-right p-2.5 font-semibold text-gray-600">Agencies</th>
                <th className="text-right p-2.5 font-semibold text-gray-600">Cylinders</th>
                <th className="text-right p-2.5 font-semibold text-gray-600">Earned</th>
                <th className="text-right p-2.5 font-semibold text-gray-600">Deducted</th>
                <th className="text-right p-2.5 font-semibold text-gray-600">Net</th>
              </tr>
            </thead>
            <tbody>
              {performance.sales_persons.map((sp, i) => (
                <tr key={sp.name || `sp-${i}`} className="border-t border-gray-100" data-testid={`sp-perf-row-${i}`}>
                  <td className="p-2.5">
                    <p className="font-medium text-gray-900">{sp.name}</p>
                    <p className="text-xs text-gray-400">{sp.mobile}</p>
                  </td>
                  <td className="p-2.5 text-right font-mono text-sm">{formatCurrency(sp.commission_rate)}</td>
                  <td className="p-2.5 text-right font-mono">{sp.agency_count}</td>
                  <td className="p-2.5 text-right font-mono font-bold">{sp.total_cylinders}</td>
                  <td className="p-2.5 text-right font-mono text-green-600">{formatCurrency(sp.total_earned)}</td>
                  <td className="p-2.5 text-right font-mono text-red-600">{formatCurrency(sp.total_deducted)}</td>
                  <td className="p-2.5 text-right">
                    <span className={`font-mono font-bold ${sp.net_earning >= 0 ? 'text-indigo-700' : 'text-red-600'}`}>
                      {formatCurrency(sp.net_earning)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-sm text-gray-400">No sales persons found</p>
      )}
    </div>
  );
}
